import {Component, OnInit, OnDestroy} from '@angular/core';
import {Router} from '@angular/router';
import {MessageService} from '../message.service';
import {RestApiService} from '../rest-api.service';
import {NotifierService} from 'angular-notifier';
import {Formatters} from 'angular-slickgrid';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-flow-client',
  templateUrl: './flow-client.component.html',
  styleUrls: ['./flow-client.component.css']
})
export class FlowClientComponent implements OnInit, OnDestroy {

  displayed = true;
  selected: number;
  categorySelected: number;
  supportGroupSelected: number;
  componentSelected: number;
  wClientSelected: number;
  show: boolean;
  totalData: number;
  selectedTitles: any[];
  respObject: any;
  categories = [];
  components = [];
  groups = [];
  users = [];
  userSelected: number;
  userName: string;
  wClients = [];
  categoriyName: string;
  componentsName: string;
  wClientName: string;
  supportGroupName: string;
  displayData: any;
  typeChecked: number;
  type: string;
  ttypes = [];

  add = false;
  del = false;
  edit = false;
  view = false;

  indicators = [];
  isError = false;
  errorMessage: string;
  private notifier: NotifierService;
  workflowLevel: any;
  indicatorSelected: any;
  private indicatorName: any;
  workflows = [];
  workflowSelected: number;
  private workflowName: string;
  private clientId: number;
  escalated: any;
  nextOffset: number;
  previousOffset: number;
  pageSize: number;
  paginationType: string;
  page_no: number;
  totalPage: number;
  private baseFlag: any;
  private userAuth: Subscription;
  offset: number;
  dataLoaded: boolean;
  showExportBtn = true;
  dataExcel = [];
  isExportDisable = false;


  constructor(private _rest: RestApiService, private messageService: MessageService, private route: Router,
              private modalService: NgbModal, notifier: NotifierService) {
    this.notifier = notifier;
    this.messageService.getCellChangeData().subscribe(item => {
      switch (item.type) {
        case 'change':
          console.log('changed');
          if (!this.messageService.edit) {
            this.notifier.notify('error', 'You do not have edit permission');
          } else {

          }
          break;
        case 'delete':
          console.log('deleted');
          if (!this.messageService.del) {
            this.notifier.notify('error', 'You do not have delete permission');
          } else {
            if (confirm('Are you sure?')) {
              this._rest.deleteWFCClient({id: item.id, user_id: this.messageService.getUserId()}).subscribe((res) => {
                this.respObject = res;
                if (this.respObject.success) {
                  // this.totalData = this.totalData - 1;
                  // this.messageService.setTotalData(this.totalData);
                  this.messageService.sendAfterDelete(item.id);
                } else {
                  this.notifier.notify('error', this.respObject.errorMessage);
                }
              }, (err) => {
                this.notifier.notify('error', this.respObject.errorMessage);
              });
            }
          }
          break;
      }
    });
    // this.messageService.getUserAuth().subscribe(details => {
    //   console.log(JSON.stringify(details));
    //   if (details.length > 0) {
    //     this.add = details[0].addFlag;
    //     this.del = details[0].deleteFlag;
    //     this.view = details[0].viewFlag;
    //     this.edit = details[0].editFlag;
    //   } else {
    //     this.add = true;
    //     this.del = true;
    //     this.view = true;
    //     this.edit = true;
    //   }
    // });
    this.messageService.getSelectedItemData().subscribe(selectedTitles => {
      if (selectedTitles.length > 0) {
        this.show = true;
        this.selected = selectedTitles.length;
      } else {
        this.show = false;
      }
    });
  }

  ngOnInit() {
    this.dataLoaded = false;
    this.nextOffset = 0;
    this.previousOffset = 0;
    this.pageSize = this.messageService.pageSize;
    this.page_no = 0;
    this.totalPage = 0;
    this.displayData = {
      pageName: 'Maintain Client Mapping with Workflow ',
      openModalButton: 'Map Forward Workflow with Client',
      breadcrumb: 'workflowClient',
      folderName: 'All WorkflowClient mapping',
      tabName: 'Client Mapping with Forward Workflow',
      exportBtn: 'Export to excel'

    };
    const columnDefinitions = [
      {
        id: 'delete',
        field: 'id',
        excludeFromHeaderMenu: true,
        formatter: Formatters.deleteIcon,
        minWidth: 30,
        maxWidth: 30,
      },
      // {id: 'id', name: 'Id', field: 'id', sortable: true, minWidth: 100, filterable: true},
      {
        id: 'workflow', name: 'Workflow', field: 'workflow', sortable: true,minWidth: 100, filterable: true
      },
      {
        id: 'components', name: 'Workflow Component', field: 'comp', minWidth: 100, sortable: true, filterable: true
      },
      {
        id: 'ttype', name: 'Ticket', field: 'ticket_type', sortable: true,minWidth: 100, filterable: true
      },
      {
        id: 'category', name: 'Category', field: 'category', sortable: true,minWidth: 100, filterable: true
      },
      {
        id: 'group', name: 'Support Group', field: 'groupName', sortable: true,minWidth: 100, filterable: true
      },
      {
        id: 'user', name: 'User', field: 'user', sortable: true,minWidth: 100, filterable: true
      },
      {
        id: 'level', name: 'Level ', field: 'level', sortable: true,minWidth: 100, filterable: true
      },
      {
        id: 'indicator', name: 'Indicator', field: 'indicator', sortable: true,minWidth: 100, filterable: true
      },
      {
        id: 'parent', name: 'Parent Workflow', field: 'parent', sortable: true,minWidth: 100, filterable: true
      },
      {
        id: 'type', name: 'Type', field: 'type', sortable: true,minWidth: 100, filterable: true
      }
    ];
    this.messageService.setColumnDefinitions(columnDefinitions);
    // this.messageService.setGridWidth(2000);

    this._rest.getWorkFlow().subscribe((res) => {
      this.respObject = res;
      if (this.respObject.success) {
        this.isError = false;
        this.respObject.details[0].unshift({id: 0, name: 'Select Workflow'});
        this.respObject.details[1].unshift({id: 0, name: 'Select Indicators'});
        this.workflows = this.respObject.details[0];
        this.indicators = this.respObject.details[1];
        this.workflowSelected = 0;
      } else {
        this.isError = true;
        this.errorMessage = this.respObject.errorMessage;
      }
    }, (err) => {
      this.isError = true;
      this.errorMessage = this.messageService.SERVER_ERROR;
    });
    if (this.messageService.clientId) {
      this.clientId = this.messageService.clientId;
      this.baseFlag = this.messageService.baseFlag;
      this.onPageLoad();
    } else {
      this.userAuth = this.messageService.getClientUserAuth().subscribe(auth => {
        this.view = auth[0].viewFlag;
        this.add = auth[0].addFlag;
        this.edit = auth[0].editFlag;
        this.del = auth[0].deleteFlag;
        this.clientId = auth[0].clientId;
        this.baseFlag = auth[0].baseFlag;
        this.onPageLoad();
      });
    }
  }

  onPageLoad() {
        this._rest.getTicketType(this.clientId).subscribe((res1) => {
          this.respObject = res1;
          if (this.respObject.success) {
            this.typeChecked = this.respObject.details[0].id;
            this.type = this.respObject.details[0].name;
            this.ttypes = this.respObject.details;
            this.getCategory();
          } else {
            this.notifier.notify('error', this.respObject.errorMessage);
          }
        }, (err) => {
          this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    this.getTableData();
  }

  changeRouting(path: string) {
    this.messageService.changeRouting(path);
  }

  onCategoryChange(selectedIndex) {
    this.categoriyName = this.categories[selectedIndex].name;
    this._rest.getSupportGroupByCategory(this.clientId, this.categorySelected).subscribe((res1) => {
      this.respObject = res1;
      if (this.respObject.success) {
        this.isError = false;
        this.respObject.details.unshift({id: 0, name: 'Select Support Group'}, {id: -1, name: 'Creator'});
        this.groups = this.respObject.details;
        this.supportGroupSelected = 0;
      } else {
        this.isError = true;
        this.errorMessage = this.respObject.errorMessage;
      }
    }, (err) => {
      this.isError = true;
      this.errorMessage = this.messageService.SERVER_ERROR;
    });
  }
  exportToExcel() {
    this.isExportDisable = true;
    this._rest.getAllForwardWorkflow(this.clientId, 'F').subscribe((res1) => {
        this.respObject = res1;
        if (this.respObject.success) {
            this.isExportDisable = false;
            this.dataExcel = this.respObject.details;
            this.messageService.exportAsExcelFile(this.dataExcel);
        } else {
            this.notifier.notify('error', this.respObject.errorMessage);
        }
    }, (err) => {
        this.notifier.notify('error', this.messageService.SERVER_ERROR);
    });
}

  openModal(content) {
    if (!this.messageService.add) {
      this.notifier.notify('error', 'You do not have add permission');
    } else {
      this.isError = false;
      this.categorySelected = 0;
      this.supportGroupSelected = 0;
      this.componentSelected = 0;
      this.indicatorSelected = 0;
      this.wClientSelected = 0;
      this.workflowSelected = 0;
      this.modalService.open(content, {size: 'sm'}).result.then((result) => {
      }, (reason) => {
      });
    }
  }

  save() {
    const catArr = [];
    const data = {
      clientId: this.clientId,
      ticket_type: this.typeChecked,
      work_flow_component_id: this.componentSelected,
      supportGroupLevelId: this.supportGroupSelected,
      wfLevel: this.workflowLevel,
      sfIndecator: this.indicatorSelected,
      workflowId: this.workflowSelected,
      flowIndicator: 'F',
      createdBy: this.messageService.getUserId()
    };
      if (String(this.supportGroupSelected) === '-1') {
          data['supportGroupLevelId'] = null;
      }
      catArr.push(this.categorySelected);
      data['category_id'] = catArr;
    if (!this.messageService.isBlankField(data)) {
      data['parent_wfcclient_id'] = this.wClientSelected;
      if (this.userSelected > 0) {
        data['refer_user_id'] = this.userSelected;
      }
      // console.log('AAAAAAAAAAAAAAAA===' + JSON.stringify(data));
      this._rest.insertWFCClient(data).subscribe((res) => {
        this.respObject = res;
        if (this.respObject.success) {
          // this.isError = false;
          // const id = this.respObject.id;
          // this.messageService.setRow({
          //   id: id,
          //   comp: this.componentsName,
          //   groupName: this.supportGroupName,
          //   client: this.categoriyName,
          //   parent: this.wClientName,
          //   level: this.workflowLevel,
          //   indicator: this.indicatorName,
          //   workflow: this.workflowName,
          //   category: this.categoriyName,
          //   user: this.userName,
          //   ticket_type: this.typeChecked
          // });
          // this.totalData = this.totalData + 1;
          // this.messageService.setTotalData(this.totalData);
          // if (this.totalData <= this.pageSize * this.page_no) {
          //     this.offset = id;
          //     this.nextOffset = 0;
          // } else {
          //     this.nextOffset = this.offset;
          // }
            this.isError = false;
            this.nextOffset = 0;
            this.page_no = 0;
            this.getTableData();
          this.categorySelected = 0;
          this.componentSelected = 0;
          this.supportGroupSelected = 0;
          this.workflowLevel = '';
          this.wClientSelected = 0;
          this.indicatorSelected = 0;
          this.workflowSelected = 0;
          this.userSelected = 0;
          this.escalated = '';
        } else {
          this.isError = true;
          this.errorMessage = this.respObject.errorMessage;
        }
      }, (err) => {
        this.isError = true;
        this.errorMessage = err;
      });
    } else {
      this.isError = true;
      this.errorMessage = this.messageService.BLANK_ERROR_MESSAGE;
    }
  }

  getTableData() {
    if (!this.messageService.view) {
      this.notifier.notify('error', 'You do not have view permission');
    } else {
      this.getData({'offset': this.nextOffset, 'paginationType': ''});
    }
  }

  isEmpty(obj) {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        return false;
      }
    }
    return true;
  }

  getData(paginationObj) {
    const offset = paginationObj.offset;
    const paginationType = paginationObj.paginationType;
    this.dataLoaded = false;
    this._rest.getWFCClient(this.clientId, offset, this.pageSize, paginationType, 'F').subscribe((res) => {
      this.respObject = res;
      this.executeResponse(this.respObject, offset, paginationType);
    }, (err) => {
      this.notifier.notify('error', err);
    });
    // this._rest.getAssetDescription(this.clientId, offset, this.pageSize, paginationType).subscribe((res) => {
    //   this.respObject = res;
    // }, (err) => {
    //   this.notifier.notify('error', this.messageService.SERVER_ERROR);
    // });
  }

    executeResponse(respObject, offset, paginationType) {
        if (respObject.success) {
          this.dataLoaded = true;
            if (offset === 0) {
                this.totalData = respObject.details.totalData[0].count;
                this.totalPage = respObject.details.totalPage;
                if (this.totalPage === 0) {
                    this.totalPage = 1;
                }
            }
            if (!this.isEmpty(respObject.details.dataObj)) {
                const data = respObject.details.dataObj;
                this.nextOffset = respObject.details.nextOffset;
                this.offset = respObject.details.nextOffset;
                this.previousOffset = respObject.details.previousOffset;
                this.messageService.setTotalData(this.totalData);
                this.messageService.setGridData(data);
                // ----------------------------------------------
                if (offset !== 0) {
                    const totalCount = this.totalData;
                    const divRes = totalCount / this.pageSize;
                    const remainder = totalCount % this.pageSize;
                    if (remainder === 0) {
                        this.totalPage = parseInt(String(divRes), 10);
                    } else {
                        this.totalPage = parseInt(String(divRes), 10) + 1;
                    }
                }
                // ------------------------------------------------
                if (paginationType === 'next') {
                    this.page_no = this.page_no + 1;
                } else if (paginationType === 'prev') {
                    this.page_no = this.page_no - 1;
                } else if (paginationType === '' && this.page_no === 0) {
                    this.page_no = this.page_no + 1;
                }
                if (this.totalData <= this.pageSize * this.page_no) {
                    this.nextOffset = 0;
                }
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'next') {
                this.nextOffset = 0;
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'prev') {
                this.previousOffset = 0;
            } else if (paginationType === '' && this.page_no === 0) {
                this.page_no = this.page_no + 1;
            }
        } else {
            this.notifier.notify('error', respObject.errorMessage);
        }
    }


  onPageSizeChange(value: any) {
    this.page_no = 0;
    this.nextOffset = 0;
    this.pageSize = value;
    this.getData({'offset': this.nextOffset, 'paginationType': ''});
  }

  ngOnDestroy(): void {
    if (this.userAuth) {
      this.userAuth.unsubscribe();
    }
  }

  onComponentsChange(selectedIndex: any) {
    this.componentsName = this.components[selectedIndex].name;
  }

  onGroupChange(selectedIndex: any) {
    this.supportGroupName = this.groups[selectedIndex].name;
    this._rest.getUserByGroup(this.clientId, this.supportGroupSelected).subscribe((res1) => {
      this.respObject = res1;
      if (this.respObject.success) {
        this.isError = false;
        this.respObject.details.unshift({id: 0, name: 'Select User'});
        this.users = this.respObject.details;
        this.userSelected = 0;
      } else {
        this.isError = true;
        this.errorMessage = this.respObject.errorMessage;
      }
    }, (err) => {
      this.isError = true;
      this.errorMessage = this.messageService.SERVER_ERROR;
    });
  }

  onWclientChange(selectedIndex: any) {
    this.wClientName = this.wClients[selectedIndex].name;
  }

  onIndicatorChange(selectedIndex: any) {
    this.indicatorName = this.indicators[selectedIndex].name;
  }

  onWorkflowChange(selectedIndex: any) {
    this.workflowName = this.workflows[selectedIndex].name;
    this._rest.getWFCClientByClientId(this.clientId, this.typeChecked, this.workflowSelected, this.categorySelected, 'F').subscribe((res) => {
      this.respObject = res;
      if (this.respObject.success) {
        // console.log(JSON.stringify(this.respObject));
        this.isError = false;
        if (this.respObject.details.length === 0) {
          this.respObject.details.unshift({id: 0, name: 'Parent'});
        }
        this.wClients = this.respObject.details;
        this.wClientSelected = this.respObject.details[0].id;
      } else {
        this.isError = true;
        this.errorMessage = this.respObject.errorMessage;
      }
    }, (err) => {
      this.isError = true;
      this.errorMessage = this.messageService.SERVER_ERROR;
    });
    this._rest.getComponentsByworkflowId(this.workflowSelected).subscribe((res) => {
      this.respObject = res;
      if (this.respObject.success) {
        this.isError = false;
        this.respObject.details.unshift({id: 0, name: 'Select Component(TableName:PrimaryKey)'});
        this.components = this.respObject.details;
        this.componentSelected = 0;
      } else {
        this.isError = true;
        this.errorMessage = this.respObject.errorMessage;
      }
    }, (err) => {
      this.isError = true;
      this.errorMessage = this.messageService.SERVER_ERROR;
    });
  }

  onUserChange(selectedIndex: any) {
    this.userName = this.users[selectedIndex].name;
  }

  onButtonChange(value) {
    this.typeChecked = value.value;
    this.getCategory();
  }

  getCategory() {
    this._rest.getCategoryByTicketTypeNDynamicLevel(this.clientId, this.typeChecked).subscribe((res1) => {
      this.respObject = res1;
      if (this.respObject.success) {
        this.isError = false;
        // console.log(this.respObject);
        this.respObject.details.unshift({id: 0, name: 'Select Category'});
        this.categories = this.respObject.details;
        this.categorySelected = 0;
      } else {
        this.isError = true;
        this.errorMessage = this.respObject.errorMessage;
      }
    }, (err) => {
      this.isError = true;
      this.errorMessage = this.messageService.SERVER_ERROR;
    });
  }
}
